export default "__VITE_ASSET__dFOSKrBD__"